<rid-mechanic-background />

@let _state = state();
@let dur = durationLeft();

<rid-mechanic-wrapper>
  <rid-top-bar
    class="block w-full"
    [name]="'Leeslijst | Timer ' + duration() + 's'"
    [steps]="1"
    [progress]="_state.type === 'INSTRUCTION' || _state.type === 'READING' ? 0 : 1"
  />

  <rid-mechanic-content>
    @if (_state.type !== 'INSTRUCTION') {
      <!-- title -->
      @if (_state.type === 'PROGRESS') {
        <rid-mechanic-title [title]="'Selecteer het laatst gelezen woord'" />
      }

      <!-- matrices -->
      <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
        @for (matrix of matricesWithAppearance(); track $index) {
          <rid-word-matrix [matrix]="matrix" (selectionChanged)="select($index, $event.index)" />
        }
      </rid-horizontal-pages>

      <!-- timer -->
      @if (_state.type === 'READING' && dur !== undefined && dur <= 5) {
        <rid-timer
          class="absolute bottom-8 block"
          animate.enter="anim-slide-from-bottom"
          animate.leave="anim-slide-to-bottom"
          [duration]="dur"
        />
      }

      <!-- buttons -->
      @if (_state.type === 'VIEWING') {
        <div class="absolute bottom-8 flex justify-center gap-4">
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Nog een keer"
            variant="SECONDARY"
            [disabled]="true"
          />
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Volgende"
            (click)="finish()"
          />
        </div>
      }

      <!-- review toast -->
      @if (_state.type === 'FEEDBACK') {
        @let prev = previousWordCount();
        <rid-feedback-toast
          [title]="_state.words + (_state.words | plural: ' woord' : ' woorden') + '!'"
          [description]="
            prev
              ? _state.words === prev
                ? 'Dat is even veel als vorige keer!'
                : _state.words < prev
                  ? 'Dat is ' + (prev - _state.words) + (prev - _state.words | plural: ' woord' : ' woorden') + ' minder dan vorige keer.'
                  : 'Dat is ' + (_state.words - prev) + (_state.words - prev | plural: ' woord' : ' woorden') + ' meer dan vorige keer!'
              : ''
          "
          [variant]="prev === undefined || _state.words <= prev ? 'INFO' : 'SUCCESS'"
          (click)="state.set({ type: 'RATING', selection: _state.selection })"
          (continued)="state.set({ type: 'RATING', selection: _state.selection })"
        />
      }

      <!-- overlay -->
      @if (_state.type === 'RATING') {
        <rid-modal-background />
        <rid-rating-modal (canceled)="state.set({ type: 'VIEWING', selection: _state.selection })" (continued)="finish()" />
      }
    }

    @if (_state.type === 'INSTRUCTION') {
      <rid-modal-background [blur]="true" />
      <rid-instruction-modal (started)="start()">
        Lees de woorden hardop.<br />Doe dit zo nauwkeurig en snel mogelijk. <br /><br />
        Je hebt hiervoor<br />
        <span class="font-bold"
          ><i-timer class="inline-block size-[1em] -rotate-7" /> {{ duration() + (duration() | plural: ' seconde' : ' seconden') }}</span
        >.
      </rid-instruction-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
